<template>
    <div>
      <Head title="Import Block CSV" />
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/blocks/cutting">Cutting Output</Link>
        <span class="text-orange-400 font-medium">/</span> Import Block CSV
      </h1>
      <div class="bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store" enctype="multipart/form-data">
          <div class="flex flex-wrap mb-2 -mr-6 p-8">
            <div v-if="has_error" class="flex items-center justify-between mb-8 max-w-3xl bg-red-400 rounded w-full lg:w-full">
              <div class="flex items-center">
                <div class="py-4 text-white text-sm font-medium">
                  <span class="ml-3">There are errors in the uploaded file</span>
                </div>
              </div>
            </div>
            <file-input 
              v-model="form.cutting_output_file"
              :error="form.errors.cutting_output_file"
              class="pb-1 pr-6 w-full lg:w-4/4"
              type="file"
              accept="text/csv"
              label="Cutting Output CSV File"
            />
            <div v-if="$page.props.errors" class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2">
              {{ $page.props.errors.cutting_output_file }}
            </div>
            <div class="pb-1 pr-6 w-full lg:w-4/4">
              <small class="form-text mt-1">
              <i>
                <strong>
                  The CSV file must have the header as the first row in the format:<br>
                  cutting_date, block_ID, dry_block_weight, SKU, quality, discount_description, quantity,
                  weight, line, and recycle_weight
                </strong>
              </i>
              </small>
            </div>
            <div v-if="has_error" class="form-error pb-1 pr-6 w-full lg:w-4/4 mb-2">
              <small class="form-text mt-1">
                <i>
                  <strong>
                    Fix the following errors in:
                  </strong>
                </i>
              </small>
              <div v-for="err in upload_errors">
                <small class="form-text mt-1">
                  <i>
                    Row: {{ err.row }}
                  </i>
                  <p v-for="(p, pindex) in err.data">
                    &nbsp;&nbsp;{{ pindex + 1 }}. {{ p }}
                  </p>
                </small>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
            <loading-button
              :loading="form.processing"
              class="btn-orange px-3 py-2 text-xs"
              type="submit"
            >
              Import CSV
            </loading-button>
          </div>
        </form>
      </div>
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Layout from '@/Shared/Layout'
  import FileInput from '@/Shared/FileInput'
  import LoadingButton from '@/Shared/LoadingButton'
  
  export default {
    components: {
      FileInput,
      Head,
      Link,
      LoadingButton,
    },
    layout: Layout,
    remember: 'form',
    props: {
      upload_errors: Array,
      has_error: Boolean,
    },
    data() {
      return {
        form: this.$inertia.form({
          cutting_output_file: null,
        }),
      }
    },
    methods: {
      store() {
        this.form.post('/blocks/cutting-outputs/import', {
          onSuccess: () => {
            this.form.reset(
              'cutting_output_file'
            )
          }
        })
      },
    },
  }
  </script>
  